import { observable } from 'mobx';

/**
 * 页面级缓存对象，可以存入缓存数据
 * 现阶段只支持内存级缓存，后续可以添加淘汰算法和持久化机制
 */
export class PageCache {
  private cacheData : Map<string, any> = observable.map();

  public setValue(key: string, data: any): void {
    this.cacheData.set(key, data);
  }

  public getValue(key: string): any {
    return this.cacheData.get(key);
  }
}
